const API_CONSTANTS = {
  services : 'https://salauno.testapps.mx/wp-admin/admin-ajax.php',
  services_fb:'https://hector-salauno.cs15.force.com/services/apexrest/Service_WebsiteLoginPacientes'
};

export default API_CONSTANTS;